import DOMPurify from 'dompurify';
import { Message } from 'jl-design-system/components/message/Message';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { Element } from 'react-scroll';
import { selectableListItem } from '../../../selectable-item';
import { Shop } from '../shop';
import styles from './SearchResults.scss';

const SelectableShopItem = selectableListItem(Shop);

export const SearchResults = memo(
  ({
    searchResultTitle,
    searchResultDescription,
    shopAddress,
    shops,
    children = null,
    onClickHandler,
    hideAddress,
    isRemote,
    beautyMessage,
  }) => {
    return (
      <div className={styles.searchResults} data-testid="SearchResults">
        <Element name="search-results-title" className={styles.SearchResultsTitleContainer}>
          <h2 data-testid="SearchResultsTitle">{searchResultTitle}</h2>
        </Element>
        {!searchResultDescription ? null : (
          <p className={styles.searchResultDescription}>{searchResultDescription}</p>
        )}
        <div className={styles.SelectableShopItemContainer}>
          {
            /* prettier-ignore */
            !isRemote && beautyMessage ?
            <Message
              type="information"
              title={<div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(beautyMessage, { ADD_ATTR: ['target'] }) }} />}
              className={styles.BeautyMessage}
            /> : null
          }
          {children}
          <div className={styles.ShopsList} data-testid="ShopsList">
            {shops.map((shop) => (
              <SelectableShopItem
                dataTest="SelectableShop"
                key={shop.id}
                shop={shop}
                hideAddress={hideAddress}
                handleSelect={() => onClickHandler(shop)}
                shopAddress={shopAddress}
              />
            ))}
          </div>
        </div>
      </div>
    );
  },
);

SearchResults.displayName = 'SearchResults';

const shopShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  distance: PropTypes.number.isRequired,
});

SearchResults.propTypes = {
  shops: PropTypes.arrayOf(shopShape.isRequired).isRequired,
  searchResultTitle: PropTypes.string.isRequired,
  searchResultDescription: PropTypes.string,
  shopAddress: PropTypes.string,
  children: PropTypes.node,
  onClickHandler: PropTypes.func.isRequired,
  hideAddress: PropTypes.bool.isRequired,
  isRemote: PropTypes.bool,
  beautyMessage: PropTypes.string,
};
